import { gql } from '@apollo/client';
import buildLimitAndOffset from 'api/pagination/buildLimitAndOffset';
import DELIVERY_LOG_STATUS from './DELIVERY_LOG_STATUS';

export const GET_WEBHOOK_DELIVERY_LOGS = gql`
  query WebhookDeliveryLogs($limit: Int!, $offset: Int!, $where: webhook_delivery_logs_bool_exp!) {
    webhookDeliveryLogsAggregate: webhook_delivery_logs_aggregate(where: $where) {
      aggregate {
        count
      }
    }
    webhookDeliveryLogs: webhook_delivery_logs(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { createdAt: desc }
    ) {
      id
      eventId
      eventType
      responseStatus
      responseBody
      requestPayload
      resolvedIp
      durationMs
      successAt
      errorMessage
      createdAt
    }
  }
`;

export function buildVariables({ pagination, webhookConfigId, filters }) {
  const where = buildWhere({ webhookConfigId, filters });
  return {
    ...buildLimitAndOffset(pagination),
    where,
  };
}

function buildWhere({ webhookConfigId, filters }) {
  const conditions = { webhookConfigId: { _eq: webhookConfigId } };

  if (filters.eventType) {
    conditions.eventType = { _eq: filters.eventType };
  }

  if (filters.status === DELIVERY_LOG_STATUS.SUCCESS) {
    conditions.successAt = { _is_null: false };
  } else if (filters.status === DELIVERY_LOG_STATUS.FAILURE) {
    conditions.successAt = { _is_null: true };
  }

  return conditions;
}
